export const budgetUrlProvider = (period, provider) => {
  const baseUrl = `${process.env.VUE_APP_URL_SERVER}v2/finanzas/budget`
  const filters = []
  if (period) {
    filters.push(`date=${period}`)
  }
  if (provider) {
    filters.push(`vendorId=${provider}`)
  }
  const query = filters.length > 0 ? `?${filters.join("&")}`: ""
  return baseUrl + query
}
